import { baseApi } from "./api";
import {
  transUserBalanceListUrl,
  transGetChainsUrl,
  transGetChainsDepoAddrUrl,
  transGetChainsWithdAddrUrl,
  transWithdModelCommissionDataUrl,
  transRaiseWithdrawRequestUrl,
  transRaiseTransferRequestUrl,
  transCurrenciesUrl,
  transGetDepositsListUrl,
  transGetWithdrawsListUrl,
  transGetWalletsListUrl,
  transGetSpotListUrl,
  inrAdminAccountGetUrl,
  inrDepositUrl,
  inrWithdrawUrl,
  transGetTradeHistoryUrl,
} from "../constant/Api";

export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    transUserBalanceList: builder.query({
      query: () => ({
        url: transUserBalanceListUrl,
        method: "GET",
      }),
    }),

    transGetChains: builder.query({
      query: ({ symbol }) => ({
        url: `${transGetChainsUrl}?symbol=${symbol}`,
        method: "GET",
      }),
    }),

    transGetChainsDepoAddr: builder.query({
      query: ({ chain_id }) => ({
        url: `${transGetChainsDepoAddrUrl}?chain_id=${chain_id}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "DepositAddress", id: arg.chain_id },
      ],
    }),

    transGetChainsWithdAddr: builder.query({
      query: ({ chain_id }) => ({
        url: `${transGetChainsWithdAddrUrl}?chain_id=${chain_id}`,
        method: "GET",
      }),
    }),

    transWithdModelCommissionData: builder.query({
      query: ({ currency_id }) => ({
        url: `${transWithdModelCommissionDataUrl}?currency_id=${currency_id}`,
        method: "GET",
      }),
    }),

    transRaiseWithdrawRequest: builder.mutation({
      query: (body) => ({
        url: transRaiseWithdrawRequestUrl,
        method: "POST",
        body,
      }),
    }),

    transRaiseTransferRequest: builder.mutation({
      query: (body) => ({
        url: transRaiseTransferRequestUrl,
        method: "POST",
        body,
      }),
    }),

    transCurrencies: builder.query({
      query: () => ({
        url: transCurrenciesUrl,
        method: "GET",
      }),
    }),

    transGetDepositsList: builder.mutation({
      query: (body) => ({
        url: transGetDepositsListUrl,
        method: "POST",
        body,
      }),
    }),

    transGetWithdrawsList: builder.mutation({
      query: (body) => ({
        url: transGetWithdrawsListUrl,
        method: "POST",
        body,
      }),
    }),

    transGetWalletsList: builder.mutation({
      query: (body) => ({
        url: transGetWalletsListUrl,
        method: "POST",
        body,
      }),
    }),

    transGetSpotList: builder.mutation({
      query: (body) => ({
        url: transGetSpotListUrl,
        method: "POST",
        body,
      }),
    }),
    inrAdminGet: builder.query({
      query: () => ({
        url: inrAdminAccountGetUrl,
        method: "GET",
      }),
    }),
    inrDeposit: builder.mutation({
      query: (body) => ({
        url: inrDepositUrl,
        method: "POST",
        body,
      }),
    }),
    inrWithdraw: builder.mutation({
      query: (body) => ({
        url: inrWithdrawUrl,
        method: "POST",
        body,
      }),
    }),

    // Trade HIstory
    tradeHistory: builder.mutation({
      query: (body) => ({
        url: transGetTradeHistoryUrl,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useTransUserBalanceListQuery,
  useTransGetChainsQuery,
  useTransGetChainsDepoAddrQuery,
  useTransGetChainsWithdAddrQuery,
  useTransWithdModelCommissionDataQuery,
  useTransRaiseWithdrawRequestMutation,
  useTransRaiseTransferRequestMutation,

  useTransCurrenciesQuery,
  useTransGetDepositsListMutation,
  useTransGetWithdrawsListMutation,
  useTransGetWalletsListMutation,
  useTransGetSpotListMutation,
  useInrAdminGetQuery,
  useInrDepositMutation,
  useInrWithdrawMutation,
  
  //Trade History
  useTradeHistoryMutation,
} = transactionApi;
